import store from "../../../store";
import base_role from "./base_role.vue";

window.ROLE =  new Vue({
    store,
    el: 'div#role_provider',
    name : "ROLE",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        base_role
    }
});
